// Meals data parsed from MealLoop.csv
export const mealsData = {
  "Staple": [
    { ingredient: "Eggs", quantity: "1", quantity_type: "", department: "dairy" },
    { ingredient: "Bread", quantity: "1", quantity_type: "", department: "bakery" },
    { ingredient: "Yogurt", quantity: "4", quantity_type: "", department: "dairy" },
    { ingredient: "Milk", quantity: "1", quantity_type: "", department: "dairy" },
    { ingredient: "Apples", quantity: "4", quantity_type: "", department: "produce" }
  ],
  "Chicken Parmesan": [
    { ingredient: "Pasta", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Marinara Sauce", quantity: "16", quantity_type: "oz", department: "grocery" },
    { ingredient: "Chicken Breast", quantity: "1", quantity_type: "lb", department: "meat" },
    { ingredient: "Bread Crumbs", quantity: "2", quantity_type: "cup", department: "grocery" },
    { ingredient: "Eggs", quantity: "4", quantity_type: "", department: "dairy" },
    { ingredient: "Flour", quantity: "2", quantity_type: "cup", department: "grocery" },
    { ingredient: "Mozzerella Cheese", quantity: "16", quantity_type: "oz", department: "dairy" },
    { ingredient: "Lettuce", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Breakfast Dinner": [
    { ingredient: "Eggs", quantity: "6", quantity_type: "", department: "dairy" },
    { ingredient: "Hash Browns", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Sausage Patty", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Bread", quantity: "1", quantity_type: "", department: "bakery" },
    { ingredient: "Spinach", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Quesadilla": [
    { ingredient: "Tortilla", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Mexican Cheese", quantity: "16", quantity_type: "oz", department: "dairy" },
    { ingredient: "Chicken Breast", quantity: "0.5", quantity_type: "lb", department: "meat" },
    { ingredient: "Fajita Seasoning", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Onion", quantity: "1", quantity_type: "", department: "produce" },
    { ingredient: "Bell Pepper", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Pirogies": [
    { ingredient: "Frozen Pirogies", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Sausage", quantity: "1", quantity_type: "", department: "meat" },
    { ingredient: "Spinach", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Tacos": [
    { ingredient: "Ground Beef", quantity: "1", quantity_type: "lb", department: "meat" },
    { ingredient: "Taco Seasoning", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Tortilla", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Mexican Cheese", quantity: "16", quantity_type: "oz", department: "dairy" },
    { ingredient: "Lettuce", quantity: "1", quantity_type: "", department: "produce" },
    { ingredient: "Salsa", quantity: "1", quantity_type: "", department: "grocery" }
  ],
  "Steak Sandwich": [
    { ingredient: "Shaved Steak", quantity: "1", quantity_type: "lb", department: "meat" },
    { ingredient: "Bread", quantity: "1", quantity_type: "", department: "bakery" },
    { ingredient: "American Cheese", quantity: "1", quantity_type: "", department: "dairy" },
    { ingredient: "French Fries", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Spaghetti & Meatballs": [
    { ingredient: "Pasta", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Frozen Meatballs", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Marinara Sauce", quantity: "16", quantity_type: "oz", department: "grocery" },
    { ingredient: "Lettuce", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Naan pizzas": [
    { ingredient: "Naan", quantity: "1", quantity_type: "", department: "bakery" },
    { ingredient: "Pizza sauce", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Mozzerella Cheese", quantity: "16", quantity_type: "oz", department: "dairy" },
    { ingredient: "Sausage", quantity: "1", quantity_type: "", department: "meat" },
    { ingredient: "Mushrooms", quantity: "1", quantity_type: "", department: "produce" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "KFC Bowl": [
    { ingredient: "Chicken Breast", quantity: "1", quantity_type: "lb", department: "meat" },
    { ingredient: "Potato", quantity: "3", quantity_type: "", department: "produce" },
    { ingredient: "Cheddar cheese", quantity: "8", quantity_type: "oz", department: "dairy" },
    { ingredient: "Frozen Corn", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Gravy", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Jacket Potato": [
    { ingredient: "Russet Potato", quantity: "3", quantity_type: "", department: "produce" },
    { ingredient: "Baked beans", quantity: "16", quantity_type: "oz", department: "grocery" },
    { ingredient: "Cheddar cheese", quantity: "8", quantity_type: "oz", department: "dairy" },
    { ingredient: "Frozen chicken", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Fajitas": [
    { ingredient: "Tortilla", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Mexican Cheese", quantity: "16", quantity_type: "oz", department: "dairy" },
    { ingredient: "Chicken Breast", quantity: "0.5", quantity_type: "lb", department: "meat" },
    { ingredient: "Fajita Seasoning", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Onion", quantity: "1", quantity_type: "", department: "produce" },
    { ingredient: "Bell Pepper", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Fish sticks": [
    { ingredient: "Fish sticks", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Fries", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Fried rice": [
    { ingredient: "Jasmine rice", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Japanese Sauce", quantity: "1", quantity_type: "", department: "grocery" },
    { ingredient: "Frozen chicken", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ],
  "Burger": [
    { ingredient: "Ground Beef", quantity: "1", quantity_type: "lb", department: "meat" },
    { ingredient: "Fries", quantity: "1", quantity_type: "", department: "frozen" },
    { ingredient: "Burger buns", quantity: "1", quantity_type: "", department: "bakery" },
    { ingredient: "American Cheese", quantity: "1", quantity_type: "", department: "dairy" },
    { ingredient: "Veggie", quantity: "1", quantity_type: "", department: "produce" }
  ]
};
